import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import requiredIf from 'react-required-if';

import Classes from '../common/Classes';
import ProductImage from '../common/exhibitingOrganisation/ProductImage';
import { Devices, ScreenSizes } from '../common/Constants';


const ProductDetailsImage = ({
  src, alt, imageSize, isEditable, onClick,
  translations, isRounded
}) => (
  <div className={Classes.productImageContainer}>
    <MediaQuery minWidth={1199}>
      <ProductImage
        src={src}
        deviceType={`${Devices.desktop}-${ScreenSizes.large}`}
        imageSize={imageSize}
        alt={alt}
        translations={translations}
        isRounded={isRounded}
        isEditable={isEditable}
        onClick={onClick}
      />
    </MediaQuery>
    <MediaQuery minWidth={992} maxWidth={1198}>
      <ProductImage
        src={src}
        deviceType={`${Devices.desktop}-${ScreenSizes.small}`}
        imageSize={imageSize}
        alt={alt}
        translations={translations}
        isRounded={isRounded}
        isEditable={isEditable}
        onClick={onClick}
      />
    </MediaQuery>
    <MediaQuery maxWidth={991}>
      <ProductImage
        src={src}
        deviceType={`${Devices.mobile}-${ScreenSizes.large}`}
        imageSize={imageSize}
        alt={alt}
        translations={translations}
        isRounded={isRounded}
        isEditable={isEditable}
        onClick={onClick}
      />
    </MediaQuery>
  </div>
);


ProductDetailsImage.propTypes = {
  src: PropTypes.string.isRequired,
  imageSize: PropTypes.string.isRequired,
  alt: PropTypes.string,
  isRounded: PropTypes.bool,
  translations: PropTypes.shape({
    buttons: PropTypes.shape({
      edit: PropTypes.string
    }),
    innovativeClipText: PropTypes.string
  }).isRequired,
  isEditable: PropTypes.bool,
  onClick: requiredIf(PropTypes.func, props => props.isEditable)
};

export default ProductDetailsImage;
